import { markerRosterCreatureVisible, type MarkerRosterViewer } from '../janus-engine/display/marker-visibility';
export { markerRosterCreatureVisible } from '../janus-engine/display/marker-visibility';

/** Apply display decisions to the strip being inserted; no encounter fetch or compile. */
export function hydrateMarkerRoster(container: ParentNode): void {
    container.querySelectorAll<HTMLElement>('[data-ft-marker-viewer]').forEach(roster => {
        const viewer = JSON.parse(roster.dataset.ftMarkerViewer || '{}') as MarkerRosterViewer;
        let count = 0;
        let divider: HTMLElement | null = null;
        let groupVisible = false;
        for (const child of Array.from(roster.children)) {
            if (!(child instanceof HTMLElement)) continue;
            if (!child.hasAttribute('data-ft-marker-creature')) {
                divider = child;
                divider.style.display = 'none';
                groupVisible = false;
                continue;
            }
            const creature = JSON.parse(child.dataset.ftMarkerCreature || '{}') as Record<string, unknown>;
            const visible = markerRosterCreatureVisible(creature, viewer);
            child.style.display = visible ? 'flex' : 'none';
            if (visible) {
                if (divider && count > 0 && !groupVisible) divider.style.display = '';
                groupVisible = true;
                count++;
            }
        }
        roster.style.setProperty('display', count ? 'flex' : 'none', 'important');
        const overlay = roster.closest<HTMLElement>('.ft-marker-roster-overlay');
        if (overlay) overlay.style.setProperty('display', count ? '' : 'none', 'important');
    });
}

Object.assign(window, { ftHydrateMarkerRoster: hydrateMarkerRoster });
